import { useEffect, useState } from 'react';
import { siteName, updateStrip } from '@/mocks/home';

const navItems = [
  { label: '剧情', href: '#intro' },
  { label: '剧集', href: '#episodes' },
  { label: '角色', href: '#characters' },
  { label: '看点', href: '#themes' },
  { label: '名场面', href: '#scenes' },
  { label: '追剧指南', href: '#guide' },
  { label: '问答', href: '#faq' },
];

export default function TopBar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className="fixed top-0 left-0 right-0 z-50">
      <div className="w-full bg-primary-950 text-primary-50">
        <div className="px-4 md:px-6 h-9 flex items-center overflow-hidden">
          <i className="ri-fire-line text-accent-400 mr-2 shrink-0" aria-hidden="true" />
          <p className="text-xs md:text-sm whitespace-nowrap text-primary-100/90 truncate">
            {updateStrip[0]}
          </p>
          <span className="hidden lg:inline text-xs md:text-sm whitespace-nowrap text-primary-200/70 ml-3">
            {updateStrip.slice(1).join('　·　')}
          </span>
        </div>
      </div>

      <div
        className={`w-full transition-colors duration-300 ${
          scrolled ? 'bg-background-50/95 backdrop-blur border-b border-background-200' : 'bg-transparent'
        }`}
      >
        <div className="px-4 md:px-6 h-16 flex items-center justify-between gap-4">
          <a href="#top" className="flex items-center gap-2 shrink-0">
            <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-600 text-primary-50 font-heading font-bold text-lg">
              欲
            </span>
            <span className={`font-heading text-lg md:text-xl font-bold ${scrolled ? 'text-foreground-950' : 'text-background-50'}`}>
              {siteName}
            </span>
          </a>

          <nav aria-label="主要导航" className="hidden md:flex items-center gap-6">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className={`text-sm font-label whitespace-nowrap transition-colors ${
                  scrolled ? 'text-foreground-700 hover:text-primary-600' : 'text-background-100 hover:text-accent-300'
                }`}
              >
                {item.label}
              </a>
            ))}
          </nav>

          <a
            href="#episodes"
            className="hidden md:inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-primary-600 text-primary-50 text-sm font-label whitespace-nowrap hover:bg-primary-700 transition-colors"
          >
            <i className="ri-play-circle-line" aria-hidden="true" />
            浏览全部剧集
          </a>

          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            aria-label="打开导航菜单"
            aria-expanded={menuOpen}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md ${
              scrolled ? 'text-foreground-950' : 'text-background-50'
            }`}
          >
            <i className={menuOpen ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'} aria-hidden="true" />
          </button>
        </div>

        {menuOpen ? (
          <nav aria-label="移动端导航" className="md:hidden bg-background-50 border-b border-background-200 px-4 py-3">
            <ul className="grid grid-cols-2 gap-1">
              {navItems.map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={() => setMenuOpen(false)}
                    className="block px-3 py-2.5 rounded-md text-sm font-label text-foreground-700 hover:bg-background-100 hover:text-primary-600"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        ) : null}
      </div>
    </header>
  );
}